module.exports = __webpack_public_path__ + "static/media/Mission Farewell - Hexagon 1.3cb79e5b.png";